import React from "react";
export default () => <svg preserveAspectRatio="none" viewBox="0 0 17 17" id="TINY_MENUiconSVG"><line x2="100%" id="line1"></line><line x2="100%" id="line2"></line><line x2="100%" id="line3"></line></svg>
